<template>
  <div v-if="userId || emptyText" class="user-details">
    {{
      !userId
        ? emptyText
        : userLookup[userId].name + ' (' + userLookup[userId].email + ')'
    }}
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {},
  props: {
    userId: { type: Number, default: null },
    emptyText: { type: String, default: null },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('user', ['userLookup']),
  },
}
</script>

<style lang="scss"></style>
